<template>
  <div class="intelligentAgriculture-page">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="main">
      <div class="top-banner">
        <h2
          style="
            font-size: 56px;
            font-weight: 500;
            position: absolute;
            color: #fff;
            left: 15%;
            top: 250px;
          "
        >
          新闻动态
        </h2>
        <h2
          style="
            font-size: 42px;
            font-weight: 500;
            position: absolute;
            color: #fff;
            left: 15%;
            top: 350px;
          "
        >
          Rural e-commerce
        </h2>
        <img
          style="width: 100%; height: auto"
          src="../../assets/img/caseDetails/smartpensionsolutions/banner2.png"
        />
      </div>
      <div class="nav-h3">
          <h3>您的当前位置：首页／新闻动态／新闻列表／新闻详情</h3>
      </div>
       <div class="news-box" style="position:relative">
           <h2 style="margin-bottom:15px">{{title}}</h2>
           <a class="back-icon" @click="back()"><img style="    width: 12px;
    height: auto;
    position: absolute;
    right: 42px;
    top: 4px;" src="../../assets/img/caseDetails/smartpensionsolutions/back.png"/>返回</a>
           <div style="    margin-bottom: 30px;
    font-size: 14px;
    color: #999;"><font>时间 :</font> {{date}} <font>来源 :</font>{{source}} </div>
           <div></div>
           <p style="    text-align: left;
    margin-bottom: 20px;
    line-height: 30px;
    letter-spacing: 1px;">{{content}}</p>
            <img v-for="( item , key ) in imglist" :key="key" style="width: 100%; height: auto;margin-bottom:20px" :src="item" />
              <!-- <ul>
                  <li v-for="( item , key ) in newslist" :key="key" @click="todetail(item.id)">
                      <h2 class="news-title">{{item.title}}</h2>
                      <p class="news-body">{{item.content}}</p>
                      <font class="news-time">{{item.updateDate}}</font><a class="news-detail" >查看详情 ></a>
                  </li>
              </ul> -->
              <p class="next-btn">上一篇 热烈欢迎台州市委领导来百倍云参观考察</p>
              <p class="next-btn">下一篇 金华开发区委领导莅临考察交流</p>
          </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Nav from "@/components/Nav";
import Foot from "@/components/Foot";
import axios from 'axios'

export default {
  name: "intelligentAgriculture",
  components: {
    Header,
    Nav,
    Foot,
  },
  data() {
    return {
      select: 1,
      date:'',
      title:'',
      source:'',
      content:"",
      imglist:"",
      pageNum:1,
      pageSize:12,
    };
  },
  mounted() {
       this.id = this.$route.query.id ? this.$route.query.id : ''
      this.getSysNews()
  },
  methods: {
      back(){
          history.go(-1)
      },
    clicknav(e) {
      this.select = e;
    },
    getSysNews(){ // 获取新闻列表

      this.$api.hardware.getSysNews(this.id ).then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data
           this.title = data.title
          this.date = data.date
          this.source = data.source
          this.content = data.content
          this.imglist = data.images.split(",")
        }
      })
     },
  },
};
</script>
<style>
.banner-title {
  width: 490px;
  height: 120px;
  position: absolute;
  top: 50%;
  right: 50%;
  margin-top: 40px;
}
.nav-h3{
    height: 50px;
    background: #F5F5F5;
   
}
.nav-h3 h3{
    width: 1200px;
    margin: auto;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
}
.news-box{
    width: 1200px;
    margin: auto;
    margin-top: 40px;
}
.news-box ul li{
    cursor: pointer;
    width: 560px;
    float: left;
    height: 148px;
    border-bottom: 1px solid #666;
    margin-bottom: 60px;
    margin-right: 40px;
}
.news-title{
font-size: 18px;
    text-align: left;
    margin-bottom: 15px;
}
.news-body{
font-size: 16px;
    text-align: left;
    margin-bottom: 15px;
    height: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.news-time{
font-size: 14px;
    text-align: left;
    float: left;
    color: #999;
}
.news-detail{
font-size: 14px;
    text-align: left;
    float: right;
     color: #999;
}
.back-icon{
    display: inline-block;
    position: absolute;
    right: 20px;
    top: 21px;
    width: 48px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
}
.next-btn{
     cursor: pointer;
    color: #666;
    font-size: 16px;
    text-align: left;
    margin-bottom: 10px;
}
</style>